import styled from "@emotion/styled/macro";
import {
  Container as BootstrapContainer,
  Row,
  Col,
  Badge as BootstrapBadge,
} from "reactstrap";

export const PageContainer = styled(BootstrapContainer)`
  padding-top: 40px;
  padding-bottom: 40px;
  max-width: 700px;
  margin: 0 auto;
  min-height: calc(90vh - 140px);
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    padding: 20px 15px;
    max-width: 95%;
    min-height: calc(100vh - 120px);
  }

  @media (max-width: 480px) {
    padding: 15px 10px;
    max-width: 100%;
    margin-top: 15px;
    min-height: auto;
    align-items: flex-start;
    padding-top: 20px;
  }
`;

export const ConfirmationCard = styled.div`
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  padding: 40px;
  width: 100%;
  margin: 20px 0;

  @media (max-width: 768px) {
    padding: 30px 20px;
    border-radius: 12px;
    margin: 15px 0;
  }

  @media (max-width: 480px) {
    padding: 24px 18px;
    border-radius: 10px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    margin: 10px 0;
  }
`;

export const Title = styled.h2`
  text-align: center;
  color: #333;
  font-weight: 800;
  font-size: 2rem;
  margin-bottom: 10px;
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 1.6rem;
  }

  @media (max-width: 480px) {
    font-size: 1.4rem;
    margin-bottom: 8px;
    line-height: 1.25;
  }
`;

export const Subtitle = styled.p`
  text-align: center;
  color: #666;
  font-style: italic;
  margin-bottom: 12px;
  font-size: 1rem;
  line-height: 1.5;
  padding: 0 10px;

  @media (max-width: 768px) {
    font-size: 0.95rem;
    margin-bottom: 16px;
    padding: 0 5px;
  }

  @media (max-width: 480px) {
    font-size: 0.875rem;
    margin-bottom: 12px;
    padding: 0;
    line-height: 1.4;
  }
`;

export const BadgeContainer = styled.div`
  text-align: center;
  margin-bottom: 20px;

  @media (max-width: 480px) {
    margin-bottom: 15px;
  }
`;

export const ProductTypeBadge = styled(BootstrapBadge)`
  font-size: 1rem;
  padding: 10px 18px;
  border-radius: 20px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;

  i {
    margin-right: 8px;
    font-size: 1rem;
  }

  @media (max-width: 768px) {
    font-size: 0.95rem;
    padding: 8px 16px;

    i {
      font-size: 0.95rem;
    }
  }

  @media (max-width: 480px) {
    font-size: 0.875rem;
    padding: 7px 14px;
    border-radius: 15px;

    i {
      margin-right: 6px;
      font-size: 0.85rem;
    }
  }
`;

export const Divider = styled.hr`
  border-color: #eee;
  margin-bottom: 30px;
  border-width: 1px;

  @media (max-width: 768px) {
    margin-bottom: 25px;
  }

  @media (max-width: 480px) {
    margin-bottom: 20px;
  }
`;

export const DetailsRow = styled(Row)`
  margin-bottom: 30px;
  font-size: 1.1rem;
  color: #333;
  line-height: 1.6;

  @media (max-width: 768px) {
    font-size: 1.05rem;
    margin-bottom: 25px;
  }

  @media (max-width: 480px) {
    font-size: 1rem;
    margin-bottom: 20px;
    line-height: 1.5;
  }
`;

export const DetailLabel = styled(Col)`
  font-weight: 700;
  color: #007bff;
  margin-bottom: 15px;
  padding-right: 10px;

  @media (max-width: 768px) {
    margin-bottom: 12px;
  }

  @media (max-width: 480px) {
    margin-bottom: 10px;
    font-size: 0.95rem;
    padding-right: 8px;
  }
`;

export const DetailValue = styled(Col)`
  margin-bottom: 15px;
  word-break: break-word;
  font-weight: 600;

  @media (max-width: 768px) {
    margin-bottom: 12px;
  }

  @media (max-width: 480px) {
    margin-bottom: 10px;
    font-size: 0.95rem;
  }
`;

export const InfoBox = styled(Col)`
  margin-top: 20px;
  padding: 16px;
  background-color: #e7f3ff;
  border-radius: 8px;
  border-left: 4px solid #004085;
  border-right: 4px solid #004085;
  line-height: 1.6;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  justify-content: center;

  strong {
    font-weight: 700;
    margin-right: 4px;
  }

  @media (max-width: 768px) {
    margin-top: 16px;
    padding: 14px;
    font-size: 0.925rem;
  }

  @media (max-width: 480px) {
    margin-top: 14px;
    padding: 12px;
    font-size: 0.875rem;
    border-radius: 6px;
    line-height: 1.5;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 15px;
  margin-top: 10px;

  @media (max-width: 768px) {
    gap: 12px;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    gap: 12px;
    margin-top: 5px;
  }
`;

export const CancelButton = styled.button`
  flex: 1;
  background-color: #868e96;



  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 12px 0;
  font-size: 1.1rem;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;

  &:hover {
    background-color: #5a6268;
    transform: translateY(-2px);
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.2);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    font-size: 1.05rem;
    padding: 11px 0;
  }

  @media (max-width: 480px) {
    font-size: 1rem;
    padding: 12px 0;
    width: 100%;
  }
`;

export const ConfirmButton = styled.button`
  flex: 1;
  background-color: ${(props) => (props.disabled ? "#ccc" : "#007bff")};
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 12px 0;
  font-size: 1.1rem;
  font-weight: 700;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  box-shadow: ${(props) =>
    props.disabled ? "none" : "0 4px 15px rgba(0, 123, 255, 0.4)"};
  transition: all 0.3s ease;
  opacity: ${(props) => (props.disabled ? "0.7" : "1")};

  &:hover {
    background-color: ${(props) => (props.disabled ? "#ccc" : "#0056b3")};
    transform: ${(props) => (props.disabled ? "none" : "translateY(-2px)")};
    box-shadow: ${(props) =>
      props.disabled ? "none" : "0 6px 20px rgba(0, 123, 255, 0.5)"};
  }

  &:active {
    transform: ${(props) => (props.disabled ? "none" : "translateY(0)")};
  }

  @media (max-width: 768px) {
    font-size: 1.05rem;
    padding: 11px 0;
  }

  @media (max-width: 480px) {
    font-size: 1rem;
    padding: 12px 0;
    width: 100%;
  }
`;

export const InvalidAccessContainer = styled(BootstrapContainer)`
  padding: 50px;
  text-align: center;

  p {
    font-size: 1.1rem;
    color: #dc3545;
    font-weight: 500;
  }

  @media (max-width: 768px) {
    padding: 40px 20px;

    p {
      font-size: 1rem;
    }
  }

  @media (max-width: 480px) {
    padding: 30px 15px;

    p {
      font-size: 0.95rem;
    }
  }
`;
